import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useMemo } from 'react';
import { ContractSearchFilterBar } from '@/features/contract-and-cost/deal';
import { usePaginationSearch, useSortingSearch } from '@/lib/listPage';
import { ContractDealTable } from './-components/ContractDealTable';
import { useContractDealList } from './-query';
import { ContractDealSearchSchema, toContractDealOrderBy } from './-shared/contractDealSearchSchema';
import { useContractDealFilters } from './-shared/useContractDealFilters';
export const Route = createFileRoute('/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/')({
  component: ContractTab,
  validateSearch: zodValidator(ContractDealSearchSchema)
});
function ContractTab() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const [pagination, setPagination] = usePaginationSearch({
    search,
    onSearchChange: s => navigate({
      search: s
    })
  });
  const [sorting, setSorting] = useSortingSearch({
    search,
    onSearchChange: s => navigate({
      search: s
    })
  });
  const orderByParam = useMemo(() => toContractDealOrderBy(search.sortColumn, {
    includeSoftware: true
  }), [search.sortColumn]);
  const {
    data,
    isPending
  } = useContractDealList({
    page: search.pageIndex + 1,
    pageSize: search.pageSize,
    freeText: search.freeText,
    includeInactive: search.showTerminated || undefined,
    contractStartFrom: search.contractStartFrom,
    contractStartTo: search.contractStartTo,
    contractEndFrom: search.contractEndFrom,
    contractEndTo: search.contractEndTo,
    orderBy: orderByParam,
    orderDirection: search.sortOrder
  });
  const {
    contractStartDateFilter,
    handleContractStartDateFilterChange,
    contractEndDateFilter,
    handleContractEndDateFilterChange,
    handleShowTerminatedChange
  } = useContractDealFilters(search, navigate);
  return <>
      <ContractSearchFilterBar searchValue={search.freeText ?? ''} onSearchChange={e => navigate({
      search: prev => ({
        ...prev,
        freeText: e.target.value || undefined,
        pageIndex: 0
      })
    })} contractStartDateFilter={contractStartDateFilter} onContractStartDateFilterChange={handleContractStartDateFilterChange} contractEndDateFilter={contractEndDateFilter} onContractEndDateFilterChange={handleContractEndDateFilterChange} showTerminated={search.showTerminated} onShowTerminatedChange={handleShowTerminatedChange} />
      <ContractDealTable data={data?.items ?? []} isPending={isPending} totalCount={data?.count} pageCount={data?.maxPage} pagination={pagination} onPaginationChange={setPagination} sorting={sorting} onSortingChange={setSorting} className="flex-1 min-h-0" />
    </>;
}